export default __webpack_public_path__ + "static/media/019-global economy.abd90cca.svg";